import React, { useState, useEffect } from "react";
import { FaTrash } from "react-icons/fa"; 
import "./Settings.css";
import AddAccount from "./AddAccount";
import FooterPanel from "../SectionsPanel/FooterPanel";

const Settings = ({ user }) => {
  const [activeTab, setActiveTab] = useState("emails");

  // Email List States
  const [emails, setEmails] = useState([]);
  const [newEmail, setNewEmail] = useState("");
  const [editEmailId, setEditEmailId] = useState(null);
  const [editEmail, setEditEmail] = useState("");
  const [isAdmin, setIsAdmin] = useState(false);
  const [users, setUsers] = useState([]);

  // Fetch Emails
  const fetchEmails = async () => {
    try {
      const res = await fetch("https://security-backend-1nbc.onrender.com/api/subscribers");
      const data = await res.json();
      setEmails(data);
    } catch (err) {
      console.error("Failed to fetch emails:", err);
    }
  };

  // inside your component
const handleAddUser = (newUser) => {
  setUsers((prev) => [
    ...prev,
    {
      id: Date.now(),
      name: newUser.name,
      email: newUser.email,
      created_at: new Date(),
      admin: newUser.admin,
    },
  ]);

  // Optionally call backend API here to persist
};
const checkAdminStatus = async () => {
  const token = sessionStorage.getItem("token"); // your auth token
  if (!token) {
    console.warn("No token found for admin check");
    setIsAdmin(false);
    return;
  }

  try {
    const res = await fetch("https://security-backend-1nbc.onrender.com/api/check-admin", {
      method: "GET",
      headers: {
        "Authorization": `Bearer ${token}`, // send token to backend
      },
    });

    if (!res.ok) throw new Error(`Server error: ${res.status}`);

    const data = await res.json();
console.log("Data:", data);

// Correctly access the nested field
const adminStatus = data.users?.admin === true;
setIsAdmin(adminStatus);
console.log("Admin status:", adminStatus);
  } catch (err) {
    console.error("Failed to check admin status:", err);
    setIsAdmin(false);
  }
};

const fetchUsers = async () => {
  try {
    const token = sessionStorage.getItem("token"); // or wherever you store it after login
    const res = await fetch("https://security-backend-1nbc.onrender.com/api/all-users", {
      headers: {
        "Authorization": `Bearer ${token}`,
      },
    });

    if (!res.ok) throw new Error(`Server error: ${res.status}`);

    const data = await res.json();
    setUsers(data.users || []);
  } catch (err) {
    console.error("Failed to fetch users:", err);
  }
};
const deleteUser = async (userId) => {
  if (!window.confirm("Are you sure you want to delete this user?")) return;

  try {
    const res = await fetch(`https://security-backend-1nbc.onrender.com/api/delete-user/${userId}`, {
      method: "DELETE",
    });

    if (!res.ok) throw new Error(`Server error: ${res.status}`);

    // Remove user from local state after successful deletion
    setUsers((prevUsers) => prevUsers.filter((u) => u.id !== userId));
    console.log("User deleted:", userId);
  } catch (err) {
    console.error("Failed to delete user:", err);
  }
};



  // Load emails immediately on mount
  useEffect(() => {
    fetchEmails();
    if (isAdmin) fetchUsers();
    checkAdminStatus();
  }, [isAdmin]);

  // CRUD Functions
  const addEmail = async () => {
    if (!newEmail) return;
    await fetch("https://security-backend-1nbc.onrender.com/api/subscribers", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: newEmail }),
    });
    setNewEmail("");
    fetchEmails(); // Refresh list immediately
  };

  const updateEmail = async (id) => {
    await fetch(`https://security-backend-1nbc.onrender.com/api/subscribers/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: editEmail }),
    });
    setEditEmailId(null);
    fetchEmails(); // Refresh list immediately
  };

  const deleteEmail = async (id) => {
    await fetch(`https://security-backend-1nbc.onrender.com/api/subscribers/${id}`, { method: "DELETE" });
    fetchEmails(); // Refresh list immediately
  };
  console.log("Render: activeTab =", activeTab, "isAdmin =", isAdmin);
  return (
    <div className="settings-container">
      {/* Tabs */}
      <nav className="settings-tabs">
        <button
          className={activeTab === "emails" ? "active" : ""}
          onClick={() => setActiveTab("emails")}
        >
          Email List
        </button>
       {isAdmin && (
    <button
      className={activeTab === "admin" ? "active" : ""}
      onClick={() => setActiveTab("admin")}
    >
      Admin Panel
    </button>
  )}
      </nav>

      {/* Tab Content */}
      <div className="settings-content">
        {activeTab === "emails" && (
          <div className="email-list-container">
            <h2>Email List</h2>
            <div className="add-email">
              <input
                type="text"
                placeholder="Add new email"
                value={newEmail}
                onChange={(e) => setNewEmail(e.target.value)}
              />
              <button className="add-btn" onClick={addEmail}>Add</button>
            </div>

            <ul>
              {emails.map((item) => (
                <li key={item.id}>
                  {editEmailId === item.id ? (
  <div className="edit-row">
    <input
      className="edit-input"
      value={editEmail}
      onChange={(e) => setEditEmail(e.target.value)}
    />
    <div className="edit-buttons">
      <button
        className="save-btn"
        onClick={() => updateEmail(item.id)}
      >
        Save
      </button>
      <button
        className="cancel-btn"
        onClick={() => setEditEmailId(null)}
      >
        Cancel
      </button>
    </div>
  </div>
) : (
  <>
    <span>{item.email}</span>
    <div className="actions">
      <button
        className="edit-btn"
        onClick={() => {
          setEditEmailId(item.id);
          setEditEmail(item.email);
        }}
      >
        Edit
      </button>
      <button
        className="delete-btn"
        onClick={() => deleteEmail(item.id)}
      >
        Delete
      </button>
    </div>
  </>
)}
                </li>
              ))}
            </ul>
          </div>
        )}
{/* Admin Panel */}
     {activeTab === "admin" && isAdmin && (
  <div className="page-container">
  <div className="main-content">
    <div className="settings-content admin-panel-container">
      <div className="admin-panel-header-wrapper">
        <h2 className="admin-panel-header">Admin Panel</h2>
        <AddAccount addUser={handleAddUser} />
      </div>

      <table className="admin-panel-table">
      <thead>
        <tr>
          <th>Name</th>
          <th>Email</th>
          <th>Created At</th>
          <th>Admin</th>
          <th>Actions</th>
        </tr>
      </thead>
      <tbody>
        {users.map((user) => (
          <tr key={user.id}>
            <td>{user.name || "-"}</td>
            <td>{user.email || "-"}</td>
            <td>{user.created_at ? new Date(user.created_at).toLocaleString() : "-"}</td>
            <td>{user.admin ? "Yes" : "No"}</td>
            <td>
              <button
                className="admin-panel-delete-btn"
                onClick={() => deleteUser(user.id)}
                aria-label={`Delete ${user.email}`}
              >
                <FaTrash style={{ marginRight: 6 }} />
                Delete
              </button>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>
   </div>

</div>
)}
{/* End of admin */}
      </div>
      
      {/* Footer */}
    
    {/* Footer */}
    {/* <FooterPanel /> */}

     
    </div>

    
  );
};

export default Settings;


